import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStatus } from './useAuthStatus'

export const RequireAdmin: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  console.log('RequireAdmin: Checking admin requirements')

  try {
    const { admin, authenticated, invalidSession } = useAuthStatus()
    console.log('RequireAdmin: Auth status received', {
      admin,
      authenticated,
      invalidSession,
    })

    const location = useLocation()
    console.log('RequireAdmin: Current location:', location.pathname)

    if (invalidSession) {
      console.log(
        'RequireAdmin: Invalid session detected, redirecting to session-expired'
      )
      return <Navigate to="/session-expired" replace />
    }

    if (!authenticated) {
      console.log('RequireAdmin: Not authenticated, redirecting to login')
      return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (!admin) {
      console.log('RequireAdmin: Not admin, redirecting to app')
      return <Navigate to="/app" state={{ from: location }} replace />
    }

    console.log('RequireAdmin: Admin check passed')
    return children
  } catch (error) {
    console.error('RequireAdmin: Unexpected error:', error)
    // If there's an error, redirect to login as a safe default
    return <Navigate to="/login" replace />
  }
}
